import { render, staticRenderFns } from "./AffiliateCPAModal.vue?vue&type=template&id=9f54b5c6&scoped=true&"
import script from "./AffiliateCPAModal.vue?vue&type=script&lang=js&"
export * from "./AffiliateCPAModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f54b5c6",
  null
  
)

export default component.exports